import { IUsePasskeyReset } from "@/interfaces/activityFeedNotifications";


export function usePasskeysReset({isPopOut, timeStamp, dateStamp, client, message}: IUsePasskeyReset) {
    const screenClassName = isPopOut ? "" : "full-screen-styling";
    const userMessage = message && message?.trim()?.length > 0
        ? message 
        : "No message provided";
    const activityInfo = {
        className: screenClassName, 
        time: isPopOut ? timeStamp : undefined, 
        dateStamp: `${timeStamp} · ${dateStamp}`,
        recognitionValue: client ? `Sent from ${client}` : undefined
    }
    
    return { screenClassName, userMessage, activityInfo}
};